<script>
import SubscriberReading from '@/components/widgets/subscriber-reading.vue'
export default {
    name: 'ServiceSubscribers',
    components: {
        SubscriberReading
    },
    props: {
        subscribers: {
            type: Array,
            default: () => []
        },
        service: {
            type: Object,
            default: () => {}
        },
        withReading: {
            type: Boolean,
            default: false
        },
        loading: Boolean
    },
    data() {
        return {
            search: '',
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
        }
    },
    computed: {
        filteredSubscribers() {
            return this.subscribers.filter(subscriber => {
                return subscriber.client.toLowerCase().includes(this.search.toLowerCase())
            })
        },
        rows() {
            return this.filteredSubscribers.length
        },
    },
    methods: {
        addSubscriber(){
            this.$emit('addSubscriber')
        },
        subscriberReading(data){
            this.$emit('subscriberReading', data)
        },
        editSubscriber(data){
            this.$emit('editSubscriber', data)
        },
        removeSubscriber(data){
            this.$emit('removeSubscriber', data)
        },
        async getReading(item){
            if(!this.withReading) return;
            item.viewReading = !item.viewReading;
            if(item.viewReading){
                await this.wait(100);
                this.$refs[`subscriberReading${item.id}`][0].getData(item);
            }
        },
        printReading(item){
            this.$emit('printReading', item)
        },
    }
}
</script>
<template>
    <div>
        <div id="tickets-table_filter" class="dataTables_filter">
            <label class="d-inline-flex align-items-center">
                <b-form-input
                    autocomplete="off"
                    v-model="search"
                    type="search"
                    placeholder="Search Subscriber..."
                    class="form-control me-2 w-75"
                ></b-form-input>
                <b-form-select
                    class="form-select w-25"
                    v-model="perPage"
                    :options="pageOptions"
                ></b-form-select>
            </label>
        </div>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th class="p-2" :colspan="service.useMeterReading ? 6 : 5">
                        <h4 class="mb-0 text-pink">Subscribers List</h4>
                    </th>
                    <th style="width:150px;"  class="p-2">
                        <button type="button" class="btn btn-info btn-sm btn-block" @click="addSubscriber"><i class="bx bx-plus"></i> Add Subscribers</button>
                    </th>
                </tr>
                <tr>
                    <th style="width:25px;" v-if="service.useMeterReading"></th>
                    <th>Client</th>
                    <th style="width:200px;">Date Started</th>
                    <th style="width:200px;">Location</th>
                    <th style="width:200px;">From Template</th>
                    <th style="width:200px;">Billing Day</th>
                    <th class="text-center" style="width:150px;">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="!subscribers.length && !loading">
                    <td colspan="100%" class="text-center">No data found.</td>
                </tr>
                <tr v-if="subscribers.length && !loading && !filteredSubscribers.length">
                    <td colspan="100%">Search not found.</td>
                </tr>
                <tr v-if="loading">
                    <td colspan="100%" class="text-center">Loading...</td>
                </tr>
                <template v-for="x in filteredSubscribers" >
                    <tr :key="`A${x.id}`">
                        <td class="align-middle cursor-pointer" :class="{'bg-primary bg-soft': x.viewReading}" v-if="service.useMeterReading" @click="getReading(x)">
                            <i class="bx bx-chevron-right rotate font-size-22" :class="{'rotate-90': x.viewReading}"></i>
                        </td>
                        <td class="align-middle" :class="{'bg-primary bg-soft': x.viewReading}">
                            <a href="javascript:void(0)" class="text-white font-weight-bold" :class="{'hover-underline': service.useMeterReading}" @click="getReading(x)">{{x.client}}</a>
                        </td>
                        <td :class="{'bg-primary bg-soft': x.viewReading}">{{formatDateShort(new Date(x.dateStart))}}</td>
                        <td :class="{'bg-primary bg-soft': x.viewReading}">{{x.deliveryUnitServiceMap}}</td>
                        <td :class="{'bg-primary bg-soft': x.viewReading}" class="text-center">{{x.deliveryUnitServiceFeeTemplate || '-'}}</td>
                        <td :class="{'bg-primary bg-soft': x.viewReading}" class="text-center">{{x.billingDay != 0 ? `Every ${x.billingDay} of the month` : '-'}}</td>
                        <td :class="{'bg-primary bg-soft': x.viewReading}" class="text-center">
                            <b-dropdown
                                id="dropdown-dropleft"
                                right
                                variant="link"
                                toggle-class="text-decoration-none"
                                menu-class="dropdown-menu-end"
                                no-caret
                            >
                                <template #button-content>
                                    <i class="fas fa-ellipsis-h"></i>
                                </template>
                                <b-dropdown-item
                                    @click="getReading(x)"
                                    variant="white"
                                    v-if="withReading"
                                >
                                    <i class="bx bx-receipt me-1"></i>View Reading
                                </b-dropdown-item>
                                <b-dropdown-item
                                    @click="editSubscriber(x)"
                                    variant="white"
                                >
                                    <i class="bx bx-edit me-1"></i>Edit Subscriber
                                </b-dropdown-item>
                                <b-dropdown-item
                                    @click="removeSubscriber(x)"
                                    variant="danger"
                                >
                                    <i class="bx bx-trash me-1"></i>Delete Subscriber
                                </b-dropdown-item>
                            </b-dropdown>
                        </td>
                    </tr>
                    <tr :key="`B${x.id}`" v-if="x.viewReading">
                        <td></td>
                        <td colspan="100% - 1">
                            <SubscriberReading 
                                :ref="`subscriberReading${x.id}`"
                                :subscriber="x"
                                :service="service"
                                :loading="loading"
                                @close="x.viewReading = false"
                                @printReading="printReading"
                            />
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <div class="d-flex justify-content-end">
            <div class="dataTables_paginate paging_simple_numbers">
                <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                </ul>
            </div>
        </div>
    </div>
</template>